(function() {
  var empty = window.NEP_BL_EMPTY || [];
  if (empty.length) {
    var set = {};
    empty.forEach(function(h) { set[h] = true; });
    document.querySelectorAll('a.nep-bl__sub, a.nep-bl__cat-all').forEach(function(a) {
      var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      if (m && set[m[1]]) {
        a.removeAttribute('href');
        a.classList.add('nep-bl__empty');
        a.setAttribute('aria-disabled', 'true');
      }
    });
  }
  document.querySelectorAll('.nep-bl__section').forEach(function(section) {
    if (!section.querySelector('a.nep-bl__sub[href], a.nep-bl__cat-all[href]')) section.classList.add('nep-bl__section--empty');
  });
})();
(function() {
  var chevron = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5.5L8 10.5L13 5.5" stroke="#000" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.querySelectorAll('.nep-bl__section').forEach(function(section) {
    var header = section.querySelector('.nep-bl__cat-header');
    var subs   = section.querySelector('.nep-bl__subs');
    var catAll = section.querySelector('.nep-bl__cat-all');
    var title  = section.querySelector('.nep-bl__cat-title');
    if (!header || !subs) return;
    var left = document.createElement('div');
    left.className = 'nep-bl__cat-left';
    left.appendChild(title.cloneNode(true));
    var right = document.createElement('div');
    right.className = 'nep-bl__cat-right';
    var toggleBtn = document.createElement('button');
    toggleBtn.className = 'nep-bl__toggle';
    toggleBtn.setAttribute('aria-label', 'Expand category');
    toggleBtn.innerHTML = chevron;
    toggleBtn.style.cssText = 'border:none;background:#F6BE00;padding:0;';
    if (catAll) right.appendChild(catAll.cloneNode(true));
    right.appendChild(toggleBtn);
    header.innerHTML = '';
    header.appendChild(left);
    header.appendChild(right);
    right.querySelector('.nep-bl__cat-all') && right.querySelector('.nep-bl__cat-all').addEventListener('click', function(e){ e.stopPropagation(); });
    var drawer = document.createElement('div');
    drawer.className = 'nep-bl__drawer';
    drawer.appendChild(subs.cloneNode(true));
    subs.parentNode.replaceChild(drawer, subs);
    header.addEventListener('click', function() {
      var isOpen = section.classList.contains('is-open');
      section.classList.toggle('is-open', !isOpen);
    });
  });
})();
